import React from 'react'
import View from './View'
import Text from './TextNew'
import { COLORS } from 'src/theme'

interface Props {
  label: string
  value: string | number
  color?: 'groupBlue' | 'lightGrey' | 'successGreen' | 'errorRed'
}
const ExpandedViewProperty = ({ label, value, color = 'groupBlue' }: Props): JSX.Element => {
  return (
    <View className="flex justify-between  pt-2">
      <Text className="text-l">{label}</Text>
      <Text className="text-[14px] font-SemiBold" style={{ color: COLORS[color] }}>
        {value}
      </Text>
    </View>
  )
}

export default ExpandedViewProperty
